<template>
  <div class="wk-title">
    <h4>{{ title }}</h4>
  </div>
</template>

<script>
export default {
  name: 'WkTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.wk-title {
  font-size: 14px;
  font-weight: bold;
  margin-left: -20px;
}
</style>





